import MutationObserver from './mutation-observer'

export default MutationObserver
